<template>
  <main>
    <mdb-container fluid>
      <mdb-row class="mt-3">
        <mdb-col
          v-for="album in albums"
          :key="album.id"
          class="mb-3"
          md="4"
          sm="12"
        >
          <Album
            :id="album.id"
            :cover="album.cover"
            :title="album.title"
            :caption="album.caption"
            :description="album.description"
          />
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </main>
</template>

<script>
  import Album from '../../components/Album';
  import {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbCard,
    mdbView,
    mdbMask,
    mdbCardImage,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardBody
  } from 'mdbvue';

  export default {
    name: 'Gallery',
    components: {
      Album,
      mdbRow,
      mdbCol,
      mdbContainer,
      mdbIcon,
      mdbCard,
      mdbView,
      mdbMask,
      mdbCardImage,
      mdbCardTitle,
      mdbCardText,
      mdbCardFooter,
      mdbCardBody
    },
    data() {
      return {
        albums: [],
      }
    },
    created() {
      this.$store.commit('TOGGLE_OFF_NAVBAR_TRANSPARENT');
    },
    mounted() {
      let _timeout = 200;
      for (const i in this.$store.state.gallery.albums) {
        setTimeout(() => this.albums.push(this.$store.state.gallery.albums[i]), _timeout);
        _timeout += 200
      }
    }
  };
</script>

<style scoped>

</style>
